module.exports = __webpack_public_path__ + "media/images/seeds/ben-cb5dba4e2474dbaf1eb3aeb7da057313.jpg";